import { createSlice } from "@reduxjs/toolkit";

import {
  changeJoiningRequestStatus,
  createNewDoctors,
  uploadUserBulkUploadFile,
  fetchUserBulkUploadReview,
  fetchBulkUploadReviewUser,
  createSupportTicket,
  createUserGroup,
  fetchJoiningRequestUsers,
  fetchUserFilters,
  fetchUserGroupDetail,
  fetchUserGroups,
  fetchUsers,
  getEditDoctorDetails,
  getReminderResponse,
  updateDoctorDetails,
  updateUserGroups,
  getUserEmailSchedule,
  getUserEmailScheduleDetails,
  uploadUserGroupBulkUploadFile,
  fetchUserGroupBulkUploadReview,
  fetchBulkUploadReviewUserGroup,
} from "redux/actions/users/usersData";

const initialState = {
  userCount: 0,
  userData: [],
  userPage: 1,
  userPageSize: 10,
  userSearchQuery: "",
  userSearchCount: 0,
  userStatus: "Active",
  isUsersLoading: false,
  isReminderSending: false,
  isJoinReqUpdating: false,
  isTicketSubmitting: false,
  isUserFiltersLoading: false,
  userFilters: {
    region: null,
    clinic: null,
    roles: null,
    status: null,
    joined_groups__title: null,
  },
  userListSelected: [],
  scheduledEmails: [],
  scheduledEmailDetails: [],
  // user - selected filters
  selectedRegionFilter: "",
  selectedClinicFilter: "",
  selectedRoleFilter: "",
  selectedUserGroupFilter: "",
  selectedUserTypeFilter: "",
  // user - edit
  isUserEditDataLoading: false,
  // user - create
  userErrValidate: false,
  userCreating: false,
  userCreateFname: "",
  userCreateLname: "",
  userCreateEmail: "",
  userCreateCountryCode: "+1",
  userCreateMobile: "",
  userCreateDesignation: "",
  userCreateRole: "",
  userCreateClinic: "",
  userCreateRegion: "",
  // Bulk upload API states - user uploader
  userBulkUploadReviewLoading: true,
  userBulkUploaderReviewCountTotal: 0,
  userBulkUploaderReviewCountApproved: 0,
  userBulkUploaderReviewCountError: 0,
  userBulkUploaderReviewErrorList: [],
  userBulkUploaderValidationList: [],
  userBulkUploaderProgress: 0,
  userBulkUploadFileName: "",
  userBulkUploadFileSize: "",
  userBulkUploadFileType: "",
  userBulkUploadEditLoading: true,
  userBulkUploadEditStatus: false,
  userBulkUploadEditNpi: null,
  userBulkUploadEditEmail: "",
  userBulkUploadEditRegion: null,
  userBulkUploadEditProfessionalDesignation: null,
  userBulkUploadEditUserType: null,
  userBulkUploadEditOrganization: null,
  userBulkUploadEditClinic: null,
  userBulkUploadEditPersonalEmail: null,
  userBulkUploadEditFirstName: null,
  userBulkUploadEditLastName: null,
  userBulkUploadEditRole: null,
  userBulkUploadEditPhoneNumber: null,
  userBulkUploadEditErrorList: {},
  userBulkEditSaveLoading: false,
  userBulkPublishLoading: false,
  userBulkUploadEditData: {},
  userBulkBulkDiscardLoading: false,
  //Bulk Upload API States - user Update
  userLoading: false,
  userUpdateErrors: {},
  userUpdateDetail: {},

  // user groups - list
  userGroupsCount: 0,
  userGroupsData: [],
  userGroupsPage: 1,
  userGroupsPageSize: 10,
  isUserGroupsLoading: false,
  // user groups - create
  userGroupCreating: false,
  userGroupStep1ErrValidate: false,
  userGroupCreateStep: 1,
  userGroupCreateTitle: "",
  userGroupOrganization: "",
  userGroupCreateDescription: "",
  userGroupCreateUsers: [],
  userGroupCreateUsersDetails: [],
  userGroupUserActive: "True",
  userGroupCurrentOrg: null,
  userGroupSelectedOrg: null,
  userGroupSelectedRole: null,
  userGroupSelectedClinic: null,
  userGroupSelectedRegion: null,
  userGroupUserSortOrderBy: "",
  userGroupsSelected: [],
  allUserGroupsSelected: false,

  // Bulk upload API states - user group uploader
  userGroupBulkUploadReviewLoading: true,
  userGroupBulkUploaderReviewCountTotal: 0,
  userGroupBulkUploaderReviewCountApproved: 0,
  userGroupBulkUploaderReviewCountError: 0,
  userGroupBulkUploaderReviewErrorList: [],
  userGroupBulkUploaderValidationList: [],
  userGroupBulkUploaderProgress: 0,
  userGroupBulkUploadFileName: "",
  userGroupBulkUploadFileSize: "",
  userGroupBulkUploadFileType: "",
  userGroupBulkUploadEditLoading: true,
  userGroupBulkUploadEditStatus: false,
  userGroupBulkUploadGroupName: "",
  userGroupBulkUploadDescription: "",
  userGroupBulkUploadUploadUserList: [],
  userGroupBulkUploadOrganizationName: "",
  userGroupBulkUploadEditNpi: null,
  userGroupBulkUploadEditEmail: "",
  userGroupBulkUploadEditRegion: null,
  userGroupBulkUploadEditProfessionalDesignation: null,
  userGroupBulkUploadEditUserType: null,
  userGroupBulkUploadEditOrganization: null,
  userGroupBulkUploadEditClinic: null,
  userGroupBulkUploadEditPersonalEmail: null,
  userGroupBulkUploadEditFirstName: null,
  userGroupBulkUploadEditLastName: null,
  userGroupBulkUploadEditRole: null,
  userBulkUploadEditPhoneNumber: null,
  userGroupBulkUploadEditErrorList: {},
  userGroupBulkEditSaveLoading: false,
  useGrouprBulkPublishLoading: false,
  userGroupBulkUploadEditData: {},
  userGroupBulkBulkDiscardLoading: false,
  userGroupSelectedOrganization: "",
  //Bulk Upload API States - user group Update
  userGroupLoading: false,
  userGroupUpdateErrors: {},
  userGroupUpdateDetail: {},

  // support tickets
  supportCreateTitle: "",
  supportCreateDescription: "",
  skeletonData: [
    {
      height: 40,
      marginBottom: "10px",
    },
    {
      height: 100,
      marginBottom: "8px",
    },
    {
      height: 100,
      marginBottom: "8px",
    },
    {
      height: 100,
      marginBottom: "8px",
    },
    {
      height: 100,
      marginBottom: "8px",
    },
  ],
  allUsersSelected: false,
  scheduledEmailsInfo: {
    previous: null,
    next: null,
    count: null,
  },
  emailScheduleDetailInfo: {
    previous: null,
    next: null,
    count: null,
  },
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    users: (state, { payload }) => {},
    // Common update
    setUsersSliceData: (state, { payload }) => {
      if (payload.type && payload.type in state) {
        state[payload.type] = payload.data;
      }
    },
    toggleUsersSliceArrayData: (state, { payload }) => {
      if (payload.type && payload.type in state) {
        let index = state[payload.type].indexOf(payload.data);
        if (payload.type === "userGroupCreateUsersDetails") {
          index = state[payload.type].findIndex(
            (user) => user.email === payload.data.email
          );
        }

        if (index !== -1) {
          // remove from array of question ids
          state[payload.type].splice(index, 1);
        } else {
          state[payload.type].push(payload.data);
        }
      }
    },
    updateUserDataKey: (state, { payload }) => {
      if (payload.selectedId && payload.selectedId.constructor === String) {
        state.userData.forEach(function (user) {
          if (
            user.hasOwnProperty(payload.key) &&
            user.user_id &&
            payload.selectedId === user.user_id
          ) {
            user[payload.key] = payload.value;
          }
        });
      } else if (
        payload.selectedId &&
        payload.selectedId.constructor === Array
      ) {
        state.userData.forEach(function (user) {
          if (
            user.hasOwnProperty(payload.key) &&
            user.user_id &&
            payload.selectedId.includes(user.user_id)
          ) {
            user[payload.key] = payload.value;
          }
        });
      }
    },
    updateJoiningUserDataKey: (state, { payload }) => {
      if (payload.selectedId && payload.selectedId.constructor === String) {
        state.userData.forEach(function (juser) {
          if (
            juser?.user?.hasOwnProperty(payload.key) &&
            juser?.user?.user_id &&
            payload.selectedId === juser?.user?.user_id
          ) {
            juser.user[payload.key] = payload.value;
          }
        });
      } else if (
        payload.selectedId &&
        payload.selectedId.constructor === Array
      ) {
        state.userData.forEach(function (juser) {
          if (
            juser?.user?.hasOwnProperty(payload.key) &&
            juser?.user?.user_id &&
            payload.selectedId.includes(juser?.user?.user_id)
          ) {
            juser.user[payload.key] = payload.value;
          }
        });
      }
    },
    resetUserCreateData: (state, { payload }) => {
      state.userErrValidate = false;
      state.userCreating = false;
      state.userCreateFname = "";
      state.userCreateLname = "";
      state.userCreateEmail = "";
      state.userCreateCountryCode = "+1";
      state.userCreateMobile = "";
      state.userCreateDesignation = "";
      state.userCreateRole = "";
      state.userCreateClinic = "";
      state.userCreateRegion = "";
    },
    resetUserGroupData: (state, { payload }) => {
      state.userGroupCreating = false;
      state.userGroupStep1ErrValidate = false;
      state.userGroupCreateStep = 1;
      state.userGroupCreateTitle = "";
      state.userGroupOrganization = "";
      state.userGroupCreateDescription = "";
      state.userGroupCreateUsers = [];
      state.userGroupCreateUsersDetails = [];
      state.userGroupUserActive = "True";
      state.userGroupSelectedOrg = null;
      state.userGroupSelectedRole = null;
      state.userGroupSelectedClinic = null;
      state.userGroupSelectedRegion = null;
      state.userGroupCurrentOrg = null;
      state.userPage = 1;
      state.userPageSize = 10;
    },
  },
  extraReducers: {
    [fetchUsers.pending]: (state) => {
      state.isUsersLoading = true;
    },
    [fetchUsers.fulfilled]: (state, { payload }) => {
      payload?.results.forEach(function (result) {
        result.reminderSelected = false;
      });
      state.userData = payload?.results;
      state.userCount = payload?.count;
      state.isUsersLoading = false;
    },
    [fetchUsers.rejected]: (state, { payload }) => {
      state.isUsersLoading = false;
    },
    [fetchJoiningRequestUsers.pending]: (state) => {
      state.isUsersLoading = true;
    },
    [fetchJoiningRequestUsers.fulfilled]: (state, { payload }) => {
      payload.results.forEach(function (result) {
        if (result && result.user) {
          result.user.userSelected = false;
        }
      });
      state.userData = payload?.results;
      state.userCount = payload?.count;
      state.isUsersLoading = false;
    },
    [fetchJoiningRequestUsers.rejected]: (state, { payload }) => {
      state.isUsersLoading = false;
    },
    [getReminderResponse.pending]: (state) => {
      state.isReminderSending = true;
    },
    [getReminderResponse.fulfilled]: (state, { payload }) => {
      state.isReminderSending = false;
    },
    [getReminderResponse.rejected]: (state, { payload }) => {
      state.isReminderSending = false;
    },
    [changeJoiningRequestStatus.pending]: (state) => {
      state.isJoinReqUpdating = true;
    },
    [changeJoiningRequestStatus.fulfilled]: (state, { payload }) => {
      state.isJoinReqUpdating = false;
    },
    [changeJoiningRequestStatus.rejected]: (state, { payload }) => {
      state.isJoinReqUpdating = false;
    },
    [fetchUserFilters.pending]: (state) => {
      state.isUserFiltersLoading = true;
    },
    [fetchUserFilters.fulfilled]: (state, { payload }) => {
      state.isUserFiltersLoading = false;
      state.userFilters.region = payload?.region ? payload.region : null;
      state.userFilters.clinic = payload?.clinic ? payload.clinic : null;
      state.userFilters.roles = payload?.roles ? payload.roles : null;
      state.userFilters.status = payload?.status ? payload.status : null;
    },
    [fetchUserFilters.rejected]: (state, { payload }) => {
      state.isUserFiltersLoading = false;
    },
    [fetchUserGroups.pending]: (state) => {
      state.isUserGroupsLoading = true;
    },
    [fetchUserGroups.fulfilled]: (state, { payload }) => {
      state.userGroupsData = payload?.results;
      state.userGroupsCount = payload?.count;
      state.isUserGroupsLoading = false;
    },
    [fetchUserGroups.rejected]: (state, { payload }) => {
      state.isUserGroupsLoading = false;
    },
    [getEditDoctorDetails.pending]: (state) => {
      state.isUserEditDataLoading = true;
    },
    [getEditDoctorDetails.fulfilled]: (state, { payload }) => {
      if (payload?.phone_no) {
        if (payload.phone_no.startsWith("+1")) {
          state.userCreateCountryCode = "+1";
          state.userCreateMobile = payload.phone_no.slice(2);
        } else if (payload.phone_no.startsWith("+91")) {
          state.userCreateCountryCode = "+91";
          state.userCreateMobile = payload.phone_no.slice(3);
        } else {
          state.userCreateMobile = payload.phone_no;
        }
      } else {
        state.userCreateMobile = "";
      }
      state.isUserEditDataLoading = false;
      state.userCreateFname = payload?.first_name ? payload.first_name : "";
      state.userCreateLname = payload?.last_name ? payload.last_name : "";
      state.userCreateEmail = payload?.email ? payload.email : "";
      state.userCreateDesignation = payload?.professional_designation
        ? payload.professional_designation
        : "";
      state.userCreateRole = payload?.role ? payload.role : "";
      state.userCreateClinic = payload?.clinic ? payload.clinic : "";
      state.userCreateRegion = payload?.region ? payload.region : "";
    },
    [getEditDoctorDetails.rejected]: (state, { error }) => {
      state.isUserEditDataLoading = false;
      state.failed = error;
    },
    [createNewDoctors.pending]: (state) => {
      state.userCreating = true;
    },
    [createNewDoctors.fulfilled]: (state, { payload }) => {
      state.userCreating = false;
    },
    [createNewDoctors.rejected]: (state, { error }) => {
      state.userCreating = false;
    },
    [updateDoctorDetails.pending]: (state) => {
      state.userCreating = true;
    },
    [updateDoctorDetails.fulfilled]: (state, { payload }) => {
      state.userCreating = false;
    },
    [updateDoctorDetails.rejected]: (state, { error }) => {
      state.userCreating = false;
    },
    // User Bulk Upload File
    [uploadUserBulkUploadFile.pending]: (state) => {
      state.userBulkUploadReviewLoading = true;
    },
    [uploadUserBulkUploadFile.fulfilled]: (state, { payload }) => {
      if (
        payload?.total_uploaded_doctors &&
        payload.total_uploaded_doctors > 0
      ) {
        state.userBulkUploaderReviewCountTotal = payload.total_uploaded_doctors;
        state.userBulkUploaderReviewCountApproved = payload?.total_valid_doctors
          ? payload.total_valid_doctors
          : 0;
        state.userBulkUploaderReviewCountError = payload?.total_error_doctors
          ? payload.total_error_doctors
          : 0;
        state.userBulkUploaderReviewErrorList = payload?.error_list
          ? payload.error_list
          : [];
      }
      state.userBulkUploadReviewLoading = false;
    },
    [uploadUserBulkUploadFile.rejected]: (state, { payload }) => {
      state.userBulkUploadReviewLoading = false;
    },
    // Fetch User Bulk upload review
    [fetchUserBulkUploadReview.pending]: (state) => {
      state.userBulkUploadReviewLoading = true;
    },
    [fetchUserBulkUploadReview.fulfilled]: (state, { payload }) => {
      if (payload?.total_doctors && payload.total_doctors > 0) {
        state.userBulkUploaderReviewCountTotal = payload.total_doctors;
        state.userBulkUploaderReviewCountApproved =
          payload?.total_approved_doctors ? payload.total_approved_doctors : 0;
        state.userBulkUploaderReviewCountError = payload?.total_error_doctors
          ? payload.total_error_doctors
          : 0;
        state.userBulkUploaderReviewErrorList = payload?.error_doctor_list
          ? payload.error_doctor_list
          : [];
        state.userBulkUploaderValidationList = payload?.validation_error_list
          ? payload.validation_error_list
          : [];
      }
      state.userBulkUploadReviewLoading = false;
    },
    [fetchBulkUploadReviewUser.rejected]: (state, { payload }) => {
      state.userBulkUploadReviewLoading = false;
    },
    // Fetch  user bulk review - edit user
    [fetchBulkUploadReviewUser.pending]: (state) => {
      state.userBulkUploadEditLoading = true;
    },
    [fetchBulkUploadReviewUser.fulfilled]: (state, { payload }) => {
      state.userBulkUploadEditLoading = false;
      if (payload?.email) {
        state.userBulkUploadEditStatus = payload.exists
          ? payload.exists
          : false;
        state.userBulkUploadNpi = payload.npi ? payload.npi : null;
        state.userBulkUploadEditEmail = payload.email ? payload.email : "";
        state.userBulkUploadEditRegion = payload.region ? payload.region : null;
        state.userBulkUploadEditProfessionalDesignation =
          payload.professional_designation
            ? payload.professional_designation
            : null;
        state.userBulkUploadEditUserType = payload.premium
          ? payload.premium
          : null;
        state.userBulkUploadEditOrganization = payload.organization_name
          ? payload.organization_name
          : null;
        state.userBulkUploadEditClinic = payload.clinic_name
          ? payload.clinic_name
          : null;
        state.userBulkUploadEditPersonalEmail = payload.personal_email
          ? payload.personal_email
          : null;
        state.userBulkUploadEditRole = payload.role ? payload.role : null;
        state.userBulkUploadEditFirstName = payload.first_name
          ? payload.first_name
          : "";
        state.userBulkUploadEditLastName = payload.last_name
          ? payload.last_name
          : null;
        state.userBulkUploadEditPhoneNumber = payload.phone_no
          ? payload.phone_no
          : null;
        state.userBulkUploadEditNpi = payload.npi ? payload.npi : null;
        state.userBulkUploadEditErrorList = payload.errors
          ? payload.errors
          : [];
      }
    },
    [fetchBulkUploadReviewUser.rejected]: (state, { payload }) => {
      state.userBulkUploadEditLoading = false;
    },

    // User Bulk Upload File
    [uploadUserGroupBulkUploadFile.pending]: (state) => {
      state.userGroupBulkUploadReviewLoading = true;
    },
    [uploadUserGroupBulkUploadFile.fulfilled]: (state, { payload }) => {
      if (payload?.total_uploaded_groups && payload.total_uploaded_groups > 0) {
        state.userGroupBulkUploaderReviewCountTotal =
          payload.total_uploaded_groups;
        state.userGroupBulkUploaderReviewCountApproved =
          payload?.total_valid_groups ? payload.total_valid_groups : 0;
        state.userGroupBulkUploaderReviewCountError =
          payload?.total_error_groups ? payload.total_error_groups : 0;
        state.userGroupBulkUploaderReviewErrorList = payload?.error_list
          ? payload.error_list
          : [];
      }
      state.userGroupBulkUploadReviewLoading = false;
    },
    [uploadUserGroupBulkUploadFile.rejected]: (state, { payload }) => {
      state.userGroupBulkUploadReviewLoading = false;
    },
    // Fetch User Bulk upload review
    [fetchUserGroupBulkUploadReview.pending]: (state) => {
      state.userGroupBulkUploadReviewLoading = true;
    },
    [fetchUserGroupBulkUploadReview.fulfilled]: (state, { payload }) => {
      if (payload?.total_groups && payload.total_groups > 0) {
        state.userGroupBulkUploaderReviewCountTotal = payload.total_groups;
        state.userGroupBulkUploaderReviewCountApproved =
          payload?.total_approved_groups ? payload.total_approved_groups : 0;
        state.userGroupBulkUploaderReviewCountError =
          payload?.total_error_groups ? payload.total_error_groups : 0;
        state.userGroupBulkUploaderReviewErrorList = payload?.error_group_list
          ? payload.error_group_list
          : [];
        state.userGroupBulkUploaderValidationList =
          payload?.validation_error_list ? payload.validation_error_list : [];
      }
      state.userGroupBulkUploadReviewLoading = false;
    },
    [fetchBulkUploadReviewUserGroup.rejected]: (state, { payload }) => {
      state.userGroupBulkUploadReviewLoading = false;
    },
    // Fetch  user bulk review - edit user
    [fetchBulkUploadReviewUserGroup.pending]: (state) => {
      state.userGroupBulkUploadEditLoading = true;
    },
    [fetchBulkUploadReviewUserGroup.fulfilled]: (state, { payload }) => {
      state.userGroupBulkUploadEditLoading = false;

      state.userGroupBulkUploadEditStatus = payload.exists
        ? payload.exists
        : false;
      state.userGroupBulkUploadGroupName = payload.title ? payload.title : "";
      state.userGroupBulkUploadDescription = payload.description
        ? payload.description
        : null;

      state.userGroupBulkUploadUploadUserList = payload.user_emails
        ? payload.user_emails
        : [];
      state.userGroupBulkUploadOrganizationName = payload.organization_name
        ? payload.organization_name
        : null;
      state.userGroupBulkUploadEditErrorList = payload.errors
        ? payload.errors
        : [];
    },
    [fetchBulkUploadReviewUser.rejected]: (state, { payload }) => {
      state.userGroupBulkUploadEditLoading = false;
    },
    // contact support api - post
    [createSupportTicket.pending]: (state) => {
      state.isTicketSubmitting = true;
    },
    [createSupportTicket.fulfilled]: (state, { payload }) => {
      state.isTicketSubmitting = false;
    },
    [createSupportTicket.rejected]: (state, { payload }) => {
      state.isTicketSubmitting = false;
    },
    // contact user group
    [createUserGroup.pending]: (state) => {
      state.userGroupCreating = true;
    },
    [createUserGroup.fulfilled]: (state, { payload }) => {
      state.userGroupCreating = false;
    },
    [createUserGroup.rejected]: (state, { payload }) => {
      state.userGroupCreating = false;
    },
    // fetch user group detail
    [fetchUserGroupDetail.pending]: (state) => {
      state.userGroupCreating = true;
    },
    [fetchUserGroupDetail.fulfilled]: (state, { payload }) => {
      state.userGroupCreating = false;
      const data = payload?.data || {};
      state.userGroupSelectedOrg = data?.organization_name
        ? { name: data.organization_name }
        : "";
      state.userGroupCreateTitle = data?.title ? data.title : "";
      state.userGroupCreateDescription = data?.description
        ? data.description
        : "";
      state.userGroupCreateUsers = data?.users
        ? data.users.map((user) => user.email)
        : [];
      state.userGroupCreateUsersDetails = data?.users ? data.users : [];
      state.userGroupCurrentOrg = data?.organization_name
        ? data.organization_name
        : null;
    },
    [fetchUserGroupDetail.rejected]: (state, { payload }) => {
      state.userGroupCreating = false;
    },
    // update user group
    [updateUserGroups.pending]: (state) => {
      state.userGroupCreating = true;
    },
    [updateUserGroups.fulfilled]: (state, { payload }) => {
      state.userGroupCreating = false;
    },
    [updateUserGroups.rejected]: (state, { payload }) => {
      state.userGroupCreating = false;
    },
    [getUserEmailSchedule.fulfilled]: (state, { payload }) => {
      state.scheduledEmails = payload.results;
      state.scheduledEmailsInfo.count = payload.count;
      state.scheduledEmailsInfo.previous = payload.previous;
      state.scheduledEmailsInfo.next = payload.next;
    },
    [getUserEmailSchedule.rejected]: (state, {}) => {
      state.scheduledEmails = [];
      state.scheduledEmailsInfo.count = null;
      state.scheduledEmailsInfo.previous = null;
      state.scheduledEmailsInfo.next = null;
    },
    [getUserEmailScheduleDetails.fulfilled]: (state, { payload }) => {
      state.scheduledEmailDetails = payload.results;
      state.emailScheduleDetailInfo.count = payload.count;
      state.emailScheduleDetailInfo.previous = payload.previous;
      state.emailScheduleDetailInfo.next = payload.next;
    },
    [getUserEmailScheduleDetails.rejected]: (state, {}) => {
      state.scheduledEmailDetails = [];
      state.emailScheduleDetailInfo.count = null;
      state.emailScheduleDetailInfo.previous = null;
      state.emailScheduleDetailInfo.next = null;
    },
  },
});

export const {
  users,
  setUsersSliceData,
  toggleUsersSliceArrayData,
  updateUserDataKey,
  updateJoiningUserDataKey,
  resetUserCreateData,
  resetUserGroupData,
} = usersSlice.actions;

export default usersSlice.reducer;
